/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Redo_Restore_TitleInputs */



/**
* | output |
* | --- |
* | "Redo restore?" |
*
* @param {Assistant_Redo_Restore_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_redo_restore_title = /** @type {((inputs?: Assistant_Redo_Restore_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Redo_Restore_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Refaire la restauration ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiederherstellung wiederholen?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eseguire nuovamente il ripristino?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Повторить восстановление?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Rehacer la restauración?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重新恢复？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("復元をやり直しますか？")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्या पुनर्स्थापना दोबारा करनी होगी?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Refazer restauração?")
	return /** @type {LocalizedString} */ ("Redo restore?")
});